import { extendTheme } from '@mui/joy/styles';

const Theme = extendTheme({
  fontFamily: {
    display: '-apple-system, "BlinkMacSystemFont", "Ubuntu variable", "Ubuntu", "Segoe UI", "Roboto",'
      + '"Oxygen", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
    body: '-apple-system, "BlinkMacSystemFont", "Ubuntu variable", "Ubuntu", "Segoe UI", "Roboto",'
      + '"Oxygen", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          500: '#20B2A4',
          600: '#1ea89a',
          700: '#1a9386',
        },
      },
    },
    dark: {
      palette: {
        primary: {
          500: '#20B2A4',
          600: '#1ea89a',
          700: '#1a9386',
        },
      },
    },
  },
});

export default Theme;
